import { effect, inject, Injectable, Injector } from '@angular/core';
import { PlatformService } from '@big-direkt/utils/shared';
import { DarkmodeRepository } from './darkmode.repository';
import { FeatureFlagsService } from './feature-flags.service';
import { WindowService } from './window.service';

export type ColorTheme = 'dark' | 'light' | 'system';

@Injectable({
    providedIn: 'root',
})
export class DarkModeService {
    private readonly featureFlagService = inject(FeatureFlagsService);
    private readonly platformService = inject(PlatformService);
    private readonly windowService = inject(WindowService);
    private readonly darkmodeRepo = inject(DarkmodeRepository);
    private readonly injector = inject(Injector);

    public handleDarkMode(ignoreFlag = false): void {
        if (this.platformService.isPlatformServer()) {
            return;
        }

        if (!ignoreFlag) {
            const darkModeFeatureEnabled = this.featureFlagService.isFeatureEnabled('big-app-dark-mode')();

            if (!darkModeFeatureEnabled) {
                return;
            }
        }

        const selectedTheme = this.darkmodeRepo.mode;

        effect(
            () => {
                this.setTheme(selectedTheme());

                if (selectedTheme() === 'system') {
                    if (this.windowService.nativeWindow()?.matchMedia('(prefers-color-scheme: dark)').matches) {
                        this.setTheme('dark');
                    } else {
                        this.setTheme('system');
                    }
                }
            },
            { injector: this.injector },
        );
    }

    private setTheme(theme: ColorTheme): void {
        if (theme === 'dark') {
            this.windowService.document().documentElement.classList.add('dark');

            return;
        }

        this.windowService.document().documentElement.classList.remove('dark');
    }
}
